module.exports = __webpack_public_path__ + "static/media/DownloadIcon.eabebddc.svg";